import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {}, isDark: true, chartColors: {} });

const readCSSVar = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem('sm_theme') || 'dark';
    } catch { return 'dark'; }
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try { localStorage.setItem('sm_theme', theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
  const isDark = theme === 'dark';

  // Recharts-compatible colors derived from CSS vars
  const chartColors = useMemo(() => ({
    grid: readCSSVar('--chart-grid') || '#334155',
    axis: readCSSVar('--chart-axis') || '#94a3b8',
    tooltipBg: readCSSVar('--tooltip-bg') || '#1e293b',
    tooltipBorder: readCSSVar('--tooltip-border') || '#334155',
  }), [theme]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark, chartColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
